import { css } from 'styled-components';
import {
  brandFonts,
  standardColours,
  standardTransition,
  fontWeights,
} from '../../styles';

export const inputStyles = () => {
  return css`
    width: 100%;
    height: 70px;
    border: solid 1px ${standardColours.grey};
    color: ${standardColours.darkGrey};
    background-color: ${standardColours.lightGrey};
    padding: 0 30px;
    font-family: ${brandFonts.primary};
    font-weight: ${fontWeights.medium};

    &::placeholder {
      color: ${standardColours.darkGrey};
      font-weight: ${fontWeights.medium};
    }
  `;
};

export const checkboxStyles = () => {
  return css`
    position: relative;
    display: block;

    &:before,
    &:after {
      content: '';
      cursor: pointer;
      position: absolute;
      top: 50%;
      border: 1px solid ${standardColours.grey};
    }

    &:before {
      left: 0;
      width: 30px;
      height: 30px;
      transform: translateY(-50%);
      border-color: ${standardColours.grey};
      background-color: ${standardColours.lightGrey};
      transition: ${standardTransition('background-color')};
    }

    &:after {
      left: 7px;
      height: 8px;
      width: 16px;
      border-color: ${standardColours.white};
      border-top: 0;
      border-right: 0;
      opacity: 0;
      transform: translateY(calc(-50% - 2px)) rotate(-45deg);
      transition: ${standardTransition('opacity')};
    }
  `;
};
